import React from 'react';
import { motion } from 'framer-motion';

function CallToAction() {
  return (
    <section className="relative py-32 my-24 bg-gradient-to-b from-gray-50 to-white overflow-hidden">
      <div className="absolute top-0 inset-x-0 h-24 bg-gradient-to-b from-gray-100/50 to-transparent" />
      
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-br from-primary-100/30 via-transparent to-secondary-100/30" />
        <div className="absolute top-1/2 left-1/4 w-96 h-96 bg-gradient-to-br from-primary-100/20 to-transparent rounded-full blur-3xl -z-10" />
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-gradient-to-tr from-secondary-100/30 to-transparent rounded-full blur-3xl -z-10" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center"
        >
          <div className="w-24 h-1 bg-gradient-to-r from-primary-500 to-secondary-500 mx-auto mb-20 mt-12 rounded-full" />
          
          <h2 className="text-4xl font-serif text-primary-700 sm:text-5xl relative inline-block">
            Ready to Protect What Matters Most?
            <div className="absolute -bottom-2 left-0 w-full h-3 bg-secondary-100/40 -rotate-1 -z-[1]" />
          </h2>

          <p className="mt-6 text-xl text-secondary-600 max-w-3xl mx-auto">
            Get started today and create a comprehensive estate plan that protects your family and your legacy.
          </p>

          <motion.div 
            className="mt-12 flex justify-center"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <div className="rounded-md shadow-lg">
              <a 
                href="https://app.trustbuilder.law" 
                className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-primary-600 hover:bg-primary-700"
              >
                Get Started
              </a>
            </div>
          </motion.div>
        </motion.div>
      </div>

      <div className="absolute bottom-0 inset-x-0 h-24 bg-gradient-to-t from-gray-100/50 to-transparent" />
    </section>
  );
}

export default CallToAction; 